import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { FirebaseService } from 'src/app/shared/services/firebase.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ValorarCursoComponent } from '../valorar-curso/valorar-curso.component';
import { MatDialog } from '@angular/material/dialog';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { MatSnackBar } from '@angular/material/snack-bar';

interface curso {
  id: string,
  titulo: string,
  resumen: string,
  descripcion: string,
  queAprenderas: string[],
  dirigidoA: string,
  foto: string,
  nivel: string,
  instructorNombre: string,
  instructorId: string,
  instructorFoto: string,
  empresaId: string,
  empresaNombre: string,
  empresaFoto: string,
  categoria: string,
}

interface usuario {
  uid: string,
  nombreCompleto: string,
}

@Component({
  selector: 'detalle-curso-comprado',
  templateUrl: './detalle-curso-comprado.component.html',
  styleUrls: ['./detalle-curso-comprado.component.css']
})
export class DetalleCursoCompradoComponent implements OnInit {

  loaded = 0;

  constructor(
    private route: ActivatedRoute,
    private fS: FirebaseService,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    public dialog: MatDialog,
    private router: Router,
    private shared: RoutingVariablesService,
    private storage: AngularFireStorage,
    private _snackBar: MatSnackBar,
  ) { }

  // id del curso:
  id: string = this.route.snapshot.paramMap.get('id');

  // info del usuario:
  usuario = JSON.parse(localStorage.getItem('user'))

  // info del curso:
  curso: curso; /// info general del curso
  clases: any; /// array de cada uno de los modulos  
  materialDescargable: any[] = []
  examenPreguntas: number = 0;

  // info de valoracion
  valoración: number = 0;
  valorado: boolean = false;
  mensaje: string = "";

  // info de progreso:
  progreso: any; // documento completo
  porcentaje: number = 0; // porcentaje de completacion del curso 
  presentarExamen: any = 0; // Flag que determina si puede presentar el examen
  puntajeExamen = 0;

  mostrarCertificado = 0;
  linkCertificado: string = 'hola';

  ngOnInit(): void {
    this.cargarCurso();
    this.cargarProgreso();
  }
  
  // Ir al buscador /buscar con la categoria marcada
  buscarCategoria() {
    const categoria = this.curso.categoria;
    const obj = { categoria: categoria };
    this.shared.pushData(obj);
    this.router.navigate(['/buscar']);
  }

  // Cargar Informacion del curso
  cargarCurso() {
    this.afs.collection('cursos').doc(this.id).ref.get().then((snap) => {
      const data = snap.data();
      this.curso = {
        id: snap.id,
        titulo: data["titulo"],
        resumen: data["resumen"],
        descripcion: data["descripcion"],
        queAprenderas: data["queAprenderas"],
        dirigidoA: data["dirigidoA"],
        foto: data["foto"],
        nivel:data["nivel"],
        instructorNombre: data["instructorNombre"],
        instructorId: data["instructorId"],
        instructorFoto: data["instructorFoto"],
        empresaId: data["empresaId"],
        empresaNombre: data["empresaNombre"],
        empresaFoto: data["empresaFoto"],
        categoria: data["categoria"],
      }
    }).catch(error => {
      console.log(error);
    })
  }

  // Calculo de la barra de Progreso, Ver si tiene certificado y si puede presentar examen
  calculoProgreso() {
    let contador = 0
    for (let index = 0; index < this.clases.length; index++) {
      if (this.clases[index].completado == 1) {
        contador += 1;
      }
    }
    if (this.clases.length == 0) {
      this.porcentaje = 0
    } else {
      this.porcentaje = contador * 100 / this.clases.length
    }
    this.porcentaje = +(this.porcentaje * 0.9).toFixed(0)
    if (this.progreso.completado == 1) {
      this.porcentaje = 100;
    }
    if (this.porcentaje == 90) {
      this.presentarExamen = 1;
    }
    if (this.porcentaje == 100) {
      this.mostrarCertificado = 1;
    }
  }

  // Cargar documento de progreso
  cargarProgreso() {
    this.afs.collection('usuariosProgresos').ref.where("usuarioId", "==", this.usuario.uid).where("cursoId", "==", this.id)
      .get().then((response) => {
        this.progreso = response.docs[0].data();
        this.linkCertificado = 'https://predyc.com/certificado/' + this.progreso.certificado;
        this.valorado = this.progreso.valorado;
        this.clases = this.progreso.clases;
        this.puntajeExamen = this.progreso.puntaje;
        this.loaded = 1;
        this.cargarExamen();
        this.calculoProgreso();
        this.cargarMaterialDescargable();
      }).catch(error => {
        return console.log(error);
      })
  }

  // Organizar array de material descargable
  cargarMaterialDescargable() {
    for (let index = 0; index < this.clases.length; index++) {
      for (let j = 0; j < this.clases[index].archivos.length; j++) {
        this.materialDescargable = this.materialDescargable.concat(this.clases[index].archivos[j])
      }
    }
    console.log(this.materialDescargable)
  }

  // Abrir el componente para valorar el curso
  openValorarCurso() {
    const dialogRef = this.dialog.open(ValorarCursoComponent, {
      data: {
        id: this.id,
        usuarioId: this.usuario.uid,
        usuarioNombre: this.usuario.nombreCompleto,
        completado: this.progreso.completado,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result) {
        this.valorado = true;
      }
    });
  }
 
  // Redirige al componente de modulo con el modulo deseado
  irModulo(i) {
    console.log(i)
    this.shared.seleccionarModulo(i+1)
    this.router.navigate(['/est/modulo', this.id])
  }

  // Descarga el certificado
  descargarCertificado() {
    this.afs.collection('usuariosCertificados').ref.where('cursoId', '==', this.id).where('usuarioId', '==', this.usuario.uid).get()
      .then(response => {
        response.docs.forEach(doc => {
          this.router.navigate(['/certificado', doc.id])
        })
      }).catch(error => {
        return console.log(error);
      });
  };

  // Funcion auxiliar para descargar archivos
  descargarArchivo(url) {
    console.log(url)
    const ref = this.storage.refFromURL(url)
    // const ref2 = this.storage.storage.ref(url);
    ref.getDownloadURL().toPromise().then(url => {
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.open('GET', url);
      xhr.send();
    });
  }

  copiaExitosa(message: string = 'Link del certificado copiado', action: string = '') {
    this._snackBar.open(message, action, {
      duration: 1000,
      panelClass: ['gray-snackbar'],
    });
  }

  cargarExamen() {
    this.afs.collection("sesionesVisitante").doc(this.id).ref.get().then((snap) => {
      const data = snap.data();
      if (data) {
        if (data["examenPreguntas"]) {
          this.examenPreguntas = data["examenPreguntas"]
        }
      }
    })
  }

  reload() {
    location.reload();
  }

}
